<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{(editMode)?'Редактировать доступ к признакам':'Назначить доступ к признакам'}}
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <dantser-tree
            label="Пост или подразделение, которому назначается доступ"
            :source="treedata"
            ref="orgTree"
            :field="true"
            :selectMode="1"
            @node-dblclick="setWatcher($event)"
          >
          </dantser-tree>
        </v-flex>
        <v-flex xs12 sm5>
          <p class="body-2 mb-1">Признаки</p>
          <v-treeview :items="objects">
            <template slot="prepend" slot-scope="{ item, open, leaf }">
              <v-checkbox v-if="item.element_type" class="analytics-tree-checkbox" :input-value="selectedProperties.includes(item)" @click.stop="toggleSelected(item)"></v-checkbox>
              <v-icon size="20" class="mx-0" :color="item.iconcolor">{{item.icon}}</v-icon>
            </template>
            <label slot="label" class="pointer" slot-scope="{item}" @click="">{{item.name}}</label>
          </v-treeview>
        </v-flex>
        <v-flex xs12 sm1 style="position: relative">
          <v-menu offset-y style="position: sticky; top: 50%;" v-if="hasGroupProp">
            <v-btn slot="activator" icon color="secondary"><v-icon>mdi-arrow-right</v-icon></v-btn>
            <v-list>
              <v-list-tile @click="addObject(false)">
                <v-list-tile-title>Только выбранные</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="addObject(true)">
                <v-list-tile-title>Включая подчиненные</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          
          <v-btn v-else @click="addObject(false)" icon color="secondary" style="position: sticky; top: 50%;"><v-icon>mdi-arrow-right</v-icon></v-btn>
        </v-flex>
        <v-flex xs12 sm6>
          <p class="body-2 mb-1">Результат</p>
          <v-alert v-model="existError" dismissible transition="fade-transition" outline>
            {{errorMessage}}
          </v-alert>
          <v-list>
            <v-list-tile v-for="(item, index) in watcher.elements" :key="index">
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-icon size="20" class="mx-0">{{getIcon(item.element_type)}}</v-icon>
                  <v-tooltip top v-if="item.element_type!=='post' && item.element_type!=='property'">
                    <v-icon size="20" class="ml-1" slot="activator">{{item.assigned_type===0 ? 'mdi-format-list-bulleted' : 'mdi-file-tree'}}</v-icon>
                    <span>{{item.assigned_type===0 ? 'Только выбранный' : 'Включая вложенные'}}</span>
                  </v-tooltip>
                  <span>{{item.name}}</span></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon @click="deleteObject(index)"><v-icon color="error">delete</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import entities from '@/mixins/entities'
  
  export default {
    name : "AccessForm",
  
    mixins: [entities],
    
    props : {
      data : {
        type : Object,
        required : false,
        default : () => {
          return {
            watcher_id: '',
            watcher_type: 'post',
            elements: []
          }
        }
      },
      objects: {
        type: Array,
        required: false,
        default: () => []
      },
      editMode : {
        type : Boolean,
        required : false,
        default : false
      }
    },
    
    created() {
      this.watcher = JSON.parse( JSON.stringify( this.data ) )
      this.getOrgTree()
      if(this.editMode){
        this.getObjectsTree()
      }
    },
    
    computed:{
      hasGroupProp(){
        return this.selectedProperties.some( el => el.element_type==='container' || el.element_type === 'folder')
      }
    },
    
    data() {
      return {
        status : {
          btnDisabled : false,
          text : '',
          className : 'success--text darken-1'
        },
        watcher : {},
        errorMessage: '',
        existError: false,
        treedata: [],
        selectedProperties: []
      }
    },
    
    methods : {
      getOrgTree(){
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
          if(this.editMode){
            this.$nextTick(function(){
              this.$refs['orgTree'].setSelected(this.watcher.watcher_id)
            })
          }
        })
      },
  
      addObject(multiple){
        this.selectedProperties.map( item => {
          if(item.element_type && this.watcher.elements.findIndex(el => el.element_id === item.id)<0){
            let type = multiple ? 1 : 0
            if(item.element_type==='all_props') type = 2
            this.watcher.elements.push({
              element_id: item.id,
              element_type: item.element_type,
              name: item.name,
              assigned_type: type
            })
          }
        })
        this.selectedProperties = []
      },
  
      deleteObject(index){
        this.watcher.elements.splice(index, 1)
      },
      
      setWatcher(eventData){
        this.watcher.watcher_id = eventData.id
        this.watcher.watcher_type = eventData.element_type
        this.$set(this.watcher, 'name', eventData.name)
      },
      
      getObjectsTree(){
        this.$store.dispatch('analytics/constructor/assignedObjects', {id: this.watcher.watcher_id, type: this.watcher.watcher_type}).then( response => {
          this.watcher.elements = response
          this.convertArrayobjects(this.watcher.elements, 'element_id', 'element_type')
          let properties = []
          let folders = []
          this.watcher.elements.map( el => {
            if(el.element_type === 'property') properties.push(el.element_id)
            else if(el.element_type === 'folder') folders.push(el.element_id)
          })
          if(properties.length>0 || folders.length>0){
            this.$store.dispatch('analytics/constructor/propertiesData', {properties_ids: properties, folders_ids: folders}).then(response => {
              response.properties.map(item => {
                let index = this.watcher.elements.findIndex( el => (el.element_id===item.id.toString() && el.element_type==='property'))
                if(index>-1) this.watcher.elements[index].name = item.identified
              })
              response.folders.map(item => {
                let index = this.watcher.elements.findIndex( el => (el.element_id===item.id.toString() && el.element_type==='folder'))
                if(index>-1) this.watcher.elements[index].name = item.identified
              })
            })
          }
        })
      },
  
      toggleSelected(item){
        let index = this.selectedProperties.findIndex(el => (el.key === item.key && el.tree_type === item.tree_type))
        if(index<0){
          this.selectedProperties.push(item)
        } else {
          this.selectedProperties.splice(index, 1)
        }
      },
  
      getIcon(type){
        switch(type){
          case 'post':
            return 'mdi-account'
            break
          case 'container':
            return 'mdi-account-group'
            break
          case 'property':
            return 'mdi-rhombus-medium'
            break
          case 'folder':
          case 'all_props':
            return 'mdi-folder'
            break
        }
      },
      
      submit() {
        this.status = { btnDisabled : true, text : 'Сохранение', className : 'secondary--text lighten-1' }
        
        this.$store.dispatch( 'analytics/constructor/addWatcher', this.watcher ).then( response => {
          this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
          this.watcher.element_type = 'watcher'
          this.$emit('save', {type: 'watcher', data: this.watcher})
        }).catch( error => {
          this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
        })
      },
    }
    
  }
</script>

<style scoped>
  .analytics-tree-checkbox{
    width: 25px;
    flex: initial;
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/AccessForm.vue